import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchRole } from '../../../../redux/actions/roles&permissions/roles';
import { showToast } from '../../../../redux/actions/toasts';
import View from './View';

const mapDispatchToProps = (dispatch) => ({
  fetchRole: (roleId) => dispatch(fetchRole(roleId)),
  showToast: (message) => dispatch(showToast({ message })),
});

export default withRouter(connect(null, mapDispatchToProps)(View));
